
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import t from "@common/src/i18n/t";
const testingItem = namespace("testing-item");
const app = namespace("app");
@Component({})
export default class TestTemplateEdit extends Vue {
  @testingItem.Action getTestingItemList;
  @testingItem.Action saveItemTemplate;
  @testingItem.Action getTestingTemplateList;
  @testingItem.Action getTestingTemplateDetail;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  get breadData() {
    return [
      { name: t("test.detection-template"), path: "/setting/test-template" },
      {
        name: this.isAdd ? t("setting.new-test-template") : t("setting.edit-detection-template")
      }
    ];
  }
  get isAdd() {
    return this.$route.name === "settingTestTemplateAdd";
  }
  get templateId() {
    return this.$route.params.id;
  }
  mainInfoRules: any = {
    checkTemplateName: [
      {
        required: true,
        message: t("setting.enter-name-test-template"),
        trigger: "blur"
      }
    ]
  };
  showSelectTemplate: boolean = false;
  mainInfoFormData: any = {
    checkTemplateName: "",
    checkTemplateNo: "",
    status: "1"
  };
  definitionNewTestItem: any = {
    remark: "",
    checkItemCode: "",
    sort: ""
  };
  testItemsList: any = [];
  created() {
    this.init();
  }
  saveBeforeItem: any = [];
  async init() {
    this.searchTemplateMethod("");
    await this.getTestItemMethod();
    if (!this.isAdd) {
      this.getTestingTemplateDetail({
        checkTemplateCode: this.templateId
      }).then(data => {
        Object.assign(this.mainInfoFormData, data.data);
        this.newTestItemList = data.data.checkItems;
        data.data.checkItems.forEach(item => {
          // 如果检测项在检测项列表没有则加入---因为存在禁用的项目不展示在列表
          if (!this.testItemsList.some(item2 => item.checkItemCode === item2.checkItemCode)) {
            this.testItemsList.push({
              checkItemCode: item.checkItemCode,
              checkItemName: item.checkItemName
            });
          }
        });
      });
    }
    this.handleAddTestItem();
  }
  newTestItemList: any = [];
  selectedCopyTemplateCode: string = "";
  handleOpenSelectTemplate() {
    this.showSelectTemplate = true;
  }
  getTestItemMethod() {
    this.getTestingItemList({
      pageNum: 1,
      pageSize: 999
    }).then(data => {
      this.testItemsList = data.data.list;
    });
  }
  handleSaveTemplate() {
    (this.$refs.mainInfoForm as any).validate(valid => {
      if (valid && this.checkDataValid()) {
        let params = Object.assign({}, this.mainInfoFormData, {
          checkItems: this.newTestItemList.map((item, index) => {
            item.sort = index + 1;
            return item;
          })
        });
        this.btnStartLoading();
        this.saveItemTemplate(params)
          .then(() => {
            this.$message.success(t("base.save-success"));
            this.$router.push(`/setting/test-template`);
          })
          .finally(() => {
            this.btnStopLoading();
          });
      }
    });
  }
  checkDataValid() {
    if (this.newTestItemList.length < 1) {
      this.$message.error(t("setting.add-least-one-column-test-items"));
      return false;
    }
    let itemCodeIsNull = this.newTestItemList.some(item => {
      return !item.checkItemCode;
    });
    if (itemCodeIsNull) {
      this.$message.error(t("setting.search-and-select-test-items"));
      return false;
    }
    return true;
  }
  testTemplateList: any = [];
  searchTemplateMethod(val?) {
    this.getTestingTemplateList({
      pageNum: 1,
      pageSize: 10,
      status: "9",
      checkTemplateName: val
    }).then(data => {
      this.testTemplateList = data.data.list;
    });
  }
  handleSetingEnd() {
    this.getTestingTemplateDetail({
      checkTemplateCode: this.selectedCopyTemplateCode
    }).then(data => {
      this.newTestItemList = data.data.checkItems;
    });
    this.showSelectTemplate = false;
  }
  handleAddTestItem() {
    this.newTestItemList.push(Object.assign({}, this.definitionNewTestItem));
  }
  handleItemDown(idx) {
    if (idx >= this.newTestItemList.length - 1) return;
    let tempRow = this.newTestItemList[idx];
    this.newTestItemList.splice(idx, 1, this.newTestItemList[idx + 1]);
    this.newTestItemList.splice(idx + 1, 1, tempRow);
  }
  handleItemUp(idx) {
    if (idx <= 0) return;
    let tempRow = this.newTestItemList[idx];
    this.newTestItemList.splice(idx, 1, this.newTestItemList[idx - 1]);
    this.newTestItemList.splice(idx - 1, 1, tempRow);
  }
  handleInsertRow(index) {
    this.newTestItemList.splice(index + 1, 0, Object.assign({}, this.definitionNewTestItem));
  }
  handleDeleteRow(index) {
    this.newTestItemList.splice(index, 1);
  }
}
